export default "__VITE_ASSET__BLwXwnmU__"